<template>
  <div>
    <!--<span class="lighter uppercase">Profile Version {{ content.filterVersion ? content.filterVersion : '1' }}</span><br /><br />-->
    <div class="vform-label white">1 {{ $t('Corrections') }}</div>
    <table
        :style="{backgroundColor: exportProfileColors.correction}"
        class="filter-preview-table">
      <tr>
        <td><span class="lighter">{{ $t('axisMultiplier') }}</span></td>
        <td>{{ axisMultiplier }}</td>
      </tr>
      <tr>
        <td><span class="lighter">{{ $t('filter.pivotPlacement') }}:</span></td>
        <td>{{ pivotPlacement }}</td>
      </tr>
      <tr>
        <td><span class="lighter">{{ $t('pivotsField') }}:</span></td>
        <td>{{ pivotField }}</td>
      </tr>
    </table>

    <div class="vform-label white mt-3">1 {{ $t('Filter') }}</div>
    <div v-if="!stringFilters.length && !metaFilters.length && !instances.length" class="lighter">
      {{ $t('No filters applied.') }}
    </div>

    <div v-else>
      All parts will be <strong>{{ mode }}d</strong> that match the following criteria:<br/>
      <table
          :style="{backgroundColor: exportProfileColors.filter}"
          class="filter-preview-table">
        <tr v-if="stringFilters.length">
          <td>
            <div
                v-for="(value, index) in stringFilters"
                :key="index"
                class="d-inline-block">
              <div class="d-inline-block">
                Name {{ getModifierName(value.modifier) }} "{{ value.val }}"
              </div>
              <div
                  v-if="stringFilters.length > 1 && index < stringFilters.length - 1"
                  class="or-separator d-inline-block ml-2 mr-2">
                OR
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="stringFilters.length">
          <td>
            <div
                v-if="stringFilters.length && metaFilters.length"
                class="or-separator d-inline-block">
              AND
            </div>
          </td>
        </tr>
        <tr v-if="metaFilters.length">
          <td>
            <div>
              <div v-for="(value, index) in metaFilters"
                   :key="index"
                   class="d-inline-block">
                <div class="d-inline-block">
                  {{ value.metaSet }} {{ value.metaField }} {{ getModifierName(value.modifier) }} "{{ value.val }}"
                </div>
                <div
                    v-if="metaFilters.length > 1 && index < metaFilters.length - 1"
                    class="or-separator d-inline-block ml-2 mr-2">
                  AND
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="instances.length && metaFilters.length">
          <td>
            <div
                class="or-separator d-inline-block">
              AND
            </div>
          </td>
        </tr>
        <tr v-if="instances.length">
          <td>
            <div v-if="instances.length">
              {{ instances.length }} {{ $t('filter.fromSelectionGroups') }}
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div class="vform-label white mt-3">{{ $t('Merge') }}</div>
    <div v-if="!mergeMetaArray.length && !mergeStringArray.length" class="lighter">
      {{ $t('No merge rules applied.') }}
    </div>
    <div v-else>
      The following parts will be merged into one single part:<br/>
      <table
          :style="{backgroundColor: exportProfileColors.merge}"
          class="filter-preview-table">
        <tr v-if="mergeStringArray.length">
          <td>
            <div
                v-for="(value, index) in mergeStringArray"
                :key="index + 'asdfsadf'">
              <div class="d-inline-block">
                {{ value.field }} {{ getModifierName(value.modifier) }} "{{ value.val }}"
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="mergeStringArray.length && mergeMetaArray.length">
          <td>
            <div
                class="or-separator d-inline-block">
              OR
            </div>
          </td>
        </tr>
        <tr v-if="mergeMetaArray.length">
          <td>
            <div>
              <div v-for="(value, index) in mergeMetaArray"
                   :key="index + 'asdfsadfadsf'">
                <div class="d-inline-block">
                  {{ value.metaSet }} {{ value.metaField }} {{ getModifierName(value.modifier) }} "{{ value.val }}"
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {filterModifiers} from "@/enum";
import {exportProfileColors} from "@/enum";
export default {
  name: "FilterDisplay",
  props: {
    content: {type: Object, required: true}
  },
  data() {
    return {
      exportProfileColors
    };
  },
  computed: {
    config() {
      return this.content && this.content.pipeline ? this.content.pipeline : {};
    },
    axisMultiplier() {
      return this.config.axisMultiplier && !this.isZeroArray(this.config.axisMultiplier) ? this.config.axisMultiplier : '-';
    },
    pivotPlacement() {
      return this.config.pivotPlacement && this.config.pivotPlacement !== 'source' ? this.config.pivotPlacement : '-';
    },
    pivotField() {
      return this.config.pivotField ? this.config.pivotField : '-';
    },
    mode() {
      return this.config.subVersion.mode ? this.config.subVersion.mode : '-';
    },
    stringFilters() {
      return this.content.filterStringArray ? this.content.filterStringArray : [];
    },
    metaFilters() {
      return this.content.filter ? this.content.filter : [];
    },
    instances() {
      return this.content.filterIdArray ? this.content.filterIdArray : [];
    },
    mergeStringArray() {
      return this.content.mergeStringArray ? this.content.mergeStringArray : [];
    },
    mergeMetaArray() {
      return this.content.merge ? this.content.merge : [];
    }
  },
  methods: {
    isZeroArray(arr) {
      return arr.every(val => val === 0);
    },
    getModifierName(mod) {
      const item = Object.entries(filterModifiers).find(item => {
        return item[1] === mod;
      });
      return item[0] ? item[0] : 'unknown';
    },
  }
}
</script>

<style lang="scss">
.filter-preview-table {
  margin-top: 5px;
  max-width: 95%;
  border-radius: 3px;
  border-collapse: collapse;
  width: auto;
  td {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
}
</style>

<style lang="scss">
.or-separator {
  font-size: 0.7rem;
  text-align: center;
  font-weight: bold;
  width: 50px;
  background-color: var(--vform-editor-ui-quinary-color);
  opacity: 0.7;
  border-radius: 3px;
}
</style>